import { IceCategoryOrderSourceEnum } from 'shared/interfaces/category-reorder.interface';

export const DEFAULT_SYSTEM_CATEGORIES_ORDER = {
    source: IceCategoryOrderSourceEnum.SYSTEM,
    groups: [
        {
            groupId: 1,
            sortOrder: 1,
            groupTranslations: [
                {
                    language: 'English',
                    name: 'Exterior',
                },
                {
                    language: 'German',
                    name: 'Außenbereich',
                },
                {
                    language: 'French',
                    name: 'Extérieur',
                },
                {
                    language: 'Spanish',
                    name: 'Exterior',
                },
                {
                    language: 'Portuguese',
                    name: 'Exterior',
                },
                {
                    language: 'Japanese',
                    name: '外観',
                },
                {
                    language: 'Chinese',
                    name: '外部',
                },
                {
                    language: 'Italian',
                    name: 'Esterno',
                },
                {
                    language: 'Korean',
                    name: '외부',
                },
                {
                    language: 'Russian',
                    name: 'Экстерьер',
                },
                {
                    language: 'Dutch',
                    name: 'Buitenruimte',
                },
                {
                    language: 'Arabic',
                    name: 'الخارجي',
                },
            ],
            iceCategories: [
                {
                    categoryId: 1,
                    sortOrder: 1,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Exterior',
                        },
                        {
                            language: 'German',
                            name: 'Außenansicht',
                        },
                        {
                            language: 'French',
                            name: 'Extérieure',
                        },
                        {
                            language: 'Spanish',
                            name: 'Exterior',
                        },
                        {
                            language: 'Italian',
                            name: 'Esterno',
                        },
                        {
                            language: 'Chinese',
                            name: '外部的',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Exterior',
                        },
                        {
                            language: 'Japanese',
                            name: '外観',
                        },
                        {
                            language: 'Korean',
                            name: '외부',
                        },
                        {
                            language: 'Russian',
                            name: 'Внешний вид',
                        },
                        {
                            language: 'Dutch',
                            name: 'Buitenkant',
                        },
                        {
                            language: 'Arabic',
                            name: 'الخارج',
                        },
                    ],
                },
            ],
        },
        {
            groupId: 2,
            sortOrder: 2,
            groupTranslations: [
                {
                    language: 'English',
                    name: 'Lobby & Reception',
                },
                {
                    language: 'German',
                    name: 'Lobby & Rezeption',
                },
                {
                    language: 'French',
                    name: 'Hall & Réception',
                },
                {
                    language: 'Spanish',
                    name: 'Lobby y Recepción',
                },
                {
                    language: 'Portuguese',
                    name: 'Lobby e Receção',
                },
                {
                    language: 'Japanese',
                    name: 'ロビーと受付',
                },
                {
                    language: 'Chinese',
                    name: '大厅与接待处',
                },
                {
                    language: 'Italian',
                    name: 'Hall e Reception',
                },
                {
                    language: 'Korean',
                    name: '로비 및 리셉션',
                },
                {
                    language: 'Russian',
                    name: 'Лобби и Ресепшен',
                },
                {
                    language: 'Dutch',
                    name: 'Lobby & Receptie',
                },
                {
                    language: 'Arabic',
                    name: 'الردهة والاستقبال',
                },
            ],
            iceCategories: [
                {
                    categoryId: 2,
                    sortOrder: 1,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Lobby',
                        },
                        {
                            language: 'German',
                            name: 'Lobby',
                        },
                        {
                            language: 'French',
                            name: 'Lobby',
                        },
                        {
                            language: 'Spanish',
                            name: 'Lobby',
                        },
                        {
                            language: 'Italian',
                            name: 'Atrio',
                        },
                        {
                            language: 'Chinese',
                            name: '大堂',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Salão',
                        },
                        {
                            language: 'Japanese',
                            name: 'ロビー',
                        },
                        {
                            language: 'Korean',
                            name: '로비',
                        },
                        {
                            language: 'Russian',
                            name: 'Лобби',
                        },
                        {
                            language: 'Dutch',
                            name: 'Lobby',
                        },
                        {
                            language: 'Arabic',
                            name: 'ردهة',
                        },
                    ],
                },
                {
                    categoryId: 24,
                    sortOrder: 2,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Reception',
                        },
                        {
                            language: 'German',
                            name: 'Rezeption',
                        },
                        {
                            language: 'French',
                            name: 'Réception',
                        },
                        {
                            language: 'Spanish',
                            name: 'Recepción',
                        },
                        {
                            language: 'Italian',
                            name: 'Reception',
                        },
                        {
                            language: 'Chinese',
                            name: '接待',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Recepção',
                        },
                        {
                            language: 'Japanese',
                            name: '受信',
                        },
                        {
                            language: 'Korean',
                            name: '리셉션',
                        },
                        {
                            language: 'Russian',
                            name: 'Прием',
                        },
                        {
                            language: 'Dutch',
                            name: 'Receptie',
                        },
                        {
                            language: 'Arabic',
                            name: 'استقبال',
                        },
                    ],
                },
            ],
        },
        {
            groupId: 3,
            sortOrder: 3,
            groupTranslations: [
                {
                    language: 'English',
                    name: 'Guest Room & Suites',
                },
                {
                    language: 'German',
                    name: 'Gästezimmer & Suiten',
                },
                {
                    language: 'French',
                    name: 'Chambres & Suites',
                },
                {
                    language: 'Spanish',
                    name: 'Habitaciones y Suites',
                },
                {
                    language: 'Portuguese',
                    name: 'Quartos e Suítes',
                },
                {
                    language: 'Japanese',
                    name: '客室とスイート',
                },
                {
                    language: 'Chinese',
                    name: '客房与套房',
                },
                {
                    language: 'Italian',
                    name: 'Camere & Suite',
                },
                {
                    language: 'Korean',
                    name: '객실 및 스위트',
                },
                {
                    language: 'Russian',
                    name: 'Номера и Люксы',
                },
                {
                    language: 'Dutch',
                    name: 'Kamers & Suites',
                },
                {
                    language: 'Arabic',
                    name: 'الغرف والأجنحة',
                },
            ],
            iceCategories: [
                {
                    categoryId: 6,
                    sortOrder: 1,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Guest room',
                        },
                        {
                            language: 'German',
                            name: 'Gästezimmer',
                        },
                        {
                            language: 'French',
                            name: 'Chambre',
                        },
                        {
                            language: 'Spanish',
                            name: 'Habitación de huéspedes',
                        },
                        {
                            language: 'Italian',
                            name: 'Camera',
                        },
                        {
                            language: 'Chinese',
                            name: '客房',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Quarto de hóspedes',
                        },
                        {
                            language: 'Japanese',
                            name: 'ゲストルーム',
                        },
                        {
                            language: 'Korean',
                            name: '게스트 룸',
                        },
                        {
                            language: 'Russian',
                            name: 'Гостевая комната',
                        },
                        {
                            language: 'Dutch',
                            name: 'Gastenkamer',
                        },
                        {
                            language: 'Arabic',
                            name: 'غرفة الضيوف',
                        },
                    ],
                },
                {
                    categoryId: 7,
                    sortOrder: 7,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Suite',
                        },
                        {
                            language: 'German',
                            name: 'Suite',
                        },
                        {
                            language: 'French',
                            name: 'Suite',
                        },
                        {
                            language: 'Spanish',
                            name: 'Suite',
                        },
                        {
                            language: 'Italian',
                            name: 'Suite',
                        },
                        {
                            language: 'Chinese',
                            name: '套房',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Suíte',
                        },
                        {
                            language: 'Japanese',
                            name: 'スイート',
                        },
                        {
                            language: 'Korean',
                            name: '모음곡',
                        },
                        {
                            language: 'Russian',
                            name: 'Люкс',
                        },
                        {
                            language: 'Dutch',
                            name: 'Suite',
                        },
                        {
                            language: 'Arabic',
                            name: 'جناح',
                        },
                    ],
                },
                {
                    categoryId: 21,
                    sortOrder: 2,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Guest room amenity',
                        },
                        {
                            language: 'German',
                            name: 'Ausstattung eines Gästezimmers',
                        },
                        {
                            language: 'French',
                            name: 'Services de chambre',
                        },
                        {
                            language: 'Spanish',
                            name: 'Servicios de la habitación de huéspedes',
                        },
                        {
                            language: 'Italian',
                            name: 'Dotazioni della camera',
                        },
                        {
                            language: 'Chinese',
                            name: '客房设施',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Equipamento de um quarto de hóspedes',
                        },
                        {
                            language: 'Japanese',
                            name: '客室アメニティ',
                        },
                        {
                            language: 'Korean',
                            name: '객실 어메니티',
                        },
                        {
                            language: 'Russian',
                            name: 'Удобства в гостевой комнате',
                        },
                        {
                            language: 'Dutch',
                            name: 'Voorzieningen in de kamer',
                        },
                        {
                            language: 'Arabic',
                            name: 'وسائل الراحة في غرفة الضيوف',
                        },
                    ],
                },
                {
                    categoryId: 25,
                    sortOrder: 3,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Guest room bath',
                        },
                        {
                            language: 'German',
                            name: 'Badezimmer eines Gästezimmers',
                        },
                        {
                            language: 'French',
                            name: 'Baignoire de la chambre',
                        },
                        {
                            language: 'Spanish',
                            name: 'Baño de invitados',
                        },
                        {
                            language: 'Italian',
                            name: 'Camera con vasca da bagno',
                        },
                        {
                            language: 'Chinese',
                            name: '客房浴室',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Banheiro de um quarto de hóspedes',
                        },
                        {
                            language: 'Japanese',
                            name: '客室風呂',
                        },
                        {
                            language: 'Korean',
                            name: '객실 욕실',
                        },
                        {
                            language: 'Russian',
                            name: 'Ванна в гостевой комнате',
                        },
                        {
                            language: 'Dutch',
                            name: 'Gastenkamer bad',
                        },
                        {
                            language: 'Arabic',
                            name: 'حمام غرفة الضيوف',
                        },
                    ],
                },
                {
                    categoryId: 26,
                    sortOrder: 8,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Suite amenity',
                        },
                        {
                            language: 'German',
                            name: 'Einrichtung eines Gästezimmers',
                        },
                        {
                            language: 'French',
                            name: 'Services de la suite',
                        },
                        {
                            language: 'Spanish',
                            name: 'Servicios de la suite',
                        },
                        {
                            language: 'Italian',
                            name: 'Omaggio in suite',
                        },
                        {
                            language: 'Chinese',
                            name: '套房设施',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Estabelecimento de um quarto de hóspedes',
                        },
                        {
                            language: 'Japanese',
                            name: 'スイートアメニティ',
                        },
                        {
                            language: 'Korean',
                            name: '스위트 어메니티',
                        },
                        {
                            language: 'Russian',
                            name: 'Удобства в люксе',
                        },
                        {
                            language: 'Dutch',
                            name: 'Suite voorziening',
                        },
                        {
                            language: 'Arabic',
                            name: 'وسائل الراحة في الجناح',
                        },
                    ],
                },
                {
                    categoryId: 27,
                    sortOrder: 9,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Suite bath',
                        },
                        {
                            language: 'German',
                            name: 'Badezimmer einer Suite',
                        },
                        {
                            language: 'French',
                            name: 'Baignoire de la suite',
                        },
                        {
                            language: 'Spanish',
                            name: 'Baño de la suite',
                        },
                        {
                            language: 'Italian',
                            name: 'Suite con vasca da bagno',
                        },
                        {
                            language: 'Chinese',
                            name: '套房浴室',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Banheiro de uma suíte',
                        },
                        {
                            language: 'Japanese',
                            name: 'スイートバス',
                        },
                        {
                            language: 'Korean',
                            name: '스위트 욕실',
                        },
                        {
                            language: 'Russian',
                            name: 'Ванная комната',
                        },
                        {
                            language: 'Dutch',
                            name: 'Suite bad',
                        },
                        {
                            language: 'Arabic',
                            name: 'حمام الجناح',
                        },
                    ],
                },
                {
                    categoryId: 35,
                    sortOrder: 5,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Guest room kitchen/kitchenette',
                        },
                        {
                            language: 'German',
                            name: 'Küche/Kochnische im Gästezimmer',
                        },
                        {
                            language: 'French',
                            name: "Cuisine/kitchenette de la chambre d'amis",
                        },
                        {
                            language: 'Spanish',
                            name: 'Cocina/cocineta de la habitación de invitados',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Cozinha/cozinha do quarto de hóspedes',
                        },
                        {
                            language: 'Italian',
                            name: 'Camera degli ospiti cucina/angolo cottura',
                        },
                        {
                            language: 'Japanese',
                            name: '客室キッチン/キッチン',
                        },
                        {
                            language: 'Chinese',
                            name: '客房厨房/小厨房',
                        },
                        {
                            language: 'Korean',
                            name: '객실 주방/간이 주방',
                        },
                        {
                            language: 'Russian',
                            name: 'Кухня/мини-кухня в гостевой комнате',
                        },
                        {
                            language: 'Dutch',
                            name: 'Gastenkamer keuken/kitchenette',
                        },
                        {
                            language: 'Arabic',
                            name: 'مطبخ غرفة ضيوف / مطبخ صغير',
                        },
                    ],
                },
                {
                    categoryId: 36,
                    sortOrder: 6,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'View from guest room',
                        },
                        {
                            language: 'German',
                            name: 'Blick vom Gästezimmer',
                        },
                        {
                            language: 'French',
                            name: "Vue de la chambre d'amis",
                        },
                        {
                            language: 'Spanish',
                            name: 'Vista desde la habitación de invitados',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Vista do quarto de hóspedes',
                        },
                        {
                            language: 'Italian',
                            name: 'Vista dalla camera degli ospiti',
                        },
                        {
                            language: 'Japanese',
                            name: '客室からの眺め',
                        },
                        {
                            language: 'Chinese',
                            name: '从客房看',
                        },
                        {
                            language: 'Korean',
                            name: '객실에서 보이는 전망',
                        },
                        {
                            language: 'Russian',
                            name: 'Вид из гостевой комнаты',
                        },
                        {
                            language: 'Dutch',
                            name: 'Uitzicht vanuit de kamer',
                        },
                        {
                            language: 'Arabic',
                            name: 'منظر من غرفة الضيوف',
                        },
                    ],
                },
                {
                    categoryId: 37,
                    sortOrder: 11,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Suite kitchen/kitchenette',
                        },
                        {
                            language: 'German',
                            name: 'Suite-Küche/Kochnische',
                        },
                        {
                            language: 'French',
                            name: 'Cuisine/kitchenette de la suite',
                        },
                        {
                            language: 'Spanish',
                            name: 'Cocina/cocineta de la suite',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Suite cozinha/kitchenette',
                        },
                        {
                            language: 'Italian',
                            name: 'Suite cucina/angolo cottura',
                        },
                        {
                            language: 'Japanese',
                            name: 'スイートキッチン/キッチン',
                        },
                        {
                            language: 'Chinese',
                            name: '套房厨房/小厨房',
                        },
                        {
                            language: 'Korean',
                            name: '스위트 주방/간이 주방',
                        },
                        {
                            language: 'Russian',
                            name: 'Сьют кухня/мини-кухня',
                        },
                        {
                            language: 'Dutch',
                            name: 'Suite keuken/kitchenette',
                        },
                        {
                            language: 'Arabic',
                            name: 'جناح مطبخ / مطبخ صغير',
                        },
                    ],
                },
                {
                    categoryId: 38,
                    sortOrder: 12,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'View from suite',
                        },
                        {
                            language: 'German',
                            name: 'Blick von der Suite',
                        },
                        {
                            language: 'French',
                            name: 'Vue depuis la suite',
                        },
                        {
                            language: 'Spanish',
                            name: 'Vista desde la suite',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Vista da suíte',
                        },
                        {
                            language: 'Italian',
                            name: 'Vista dalla suite',
                        },
                        {
                            language: 'Japanese',
                            name: 'スイートからの眺め',
                        },
                        {
                            language: 'Chinese',
                            name: '套房景观',
                        },
                        {
                            language: 'Korean',
                            name: '스위트룸에서 본 전망',
                        },
                        {
                            language: 'Russian',
                            name: 'Вид из люкса',
                        },
                        {
                            language: 'Dutch',
                            name: 'Uitzicht vanuit suite',
                        },
                        {
                            language: 'Arabic',
                            name: 'منظر من الجناح',
                        },
                    ],
                },
                {
                    categoryId: 39,
                    sortOrder: 4,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Guest room bath (accessible)',
                        },
                        {
                            language: 'German',
                            name: 'Gästezimmer Bad (barrierefrei)',
                        },
                        {
                            language: 'French',
                            name: "Salle de bain de la chambre d'amis (accessible)",
                        },
                        {
                            language: 'Spanish',
                            name: 'Baño de la habitación de invitados (accesible)',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Banheiro do quarto de hóspedes (acessível)',
                        },
                        {
                            language: 'Japanese',
                            name: '客室バス（バリアフリー）',
                        },
                        {
                            language: 'Chinese',
                            name: '客房浴室（無障礙）',
                        },
                        {
                            language: 'Italian',
                            name: 'Bagno camera ospiti (accessibile)',
                        },
                        {
                            language: 'Korean',
                            name: '객실 욕실(접근 가능)',
                        },
                        {
                            language: 'Russian',
                            name: 'Ванна в гостевой комнате (доступно)',
                        },
                        {
                            language: 'Dutch',
                            name: 'Gastenkamer bad (toegankelijk)',
                        },
                        {
                            language: 'Arabic',
                            name: 'حمام غرفة الضيوف (يمكن الوصول إليه)',
                        },
                    ],
                },
                {
                    categoryId: 40,
                    sortOrder: 10,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Suite bath (accessible)',
                        },
                        {
                            language: 'German',
                            name: 'Suite Bad (barrierefrei)',
                        },
                        {
                            language: 'French',
                            name: 'Salle de bain attenante (accessible)',
                        },
                        {
                            language: 'Spanish',
                            name: 'Baño de la suite (accesible)',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Banheiro da suíte (acessível)',
                        },
                        {
                            language: 'Japanese',
                            name: 'スイートバス（バリアフリー）',
                        },
                        {
                            language: 'Chinese',
                            name: '套房浴室（無障礙）',
                        },
                        {
                            language: 'Italian',
                            name: 'Bagno Suite (accessibile)',
                        },
                        {
                            language: 'Korean',
                            name: '스위트 욕실(접근 가능)',
                        },
                        {
                            language: 'Russian',
                            name: 'Ванная комната (доступно)',
                        },
                        {
                            language: 'Dutch',
                            name: 'Suite bad (toegankelijk)',
                        },
                        {
                            language: 'Arabic',
                            name: 'حمام الجناح (يمكن الوصول إليه)',
                        },
                    ],
                },
            ],
        },
        {
            groupId: 4,
            sortOrder: 4,
            groupTranslations: [
                {
                    language: 'English',
                    name: 'Features',
                },
                {
                    language: 'German',
                    name: 'Merkmale',
                },
                {
                    language: 'French',
                    name: 'Caractéristiques',
                },
                {
                    language: 'Spanish',
                    name: 'Características',
                },
                {
                    language: 'Portuguese',
                    name: 'Recursos',
                },
                {
                    language: 'Japanese',
                    name: '特徴',
                },
                {
                    language: 'Chinese',
                    name: '特点',
                },
                {
                    language: 'Italian',
                    name: 'Caratteristiche',
                },
                {
                    language: 'Korean',
                    name: '특징',
                },
                {
                    language: 'Russian',
                    name: 'Особенности',
                },
                {
                    language: 'Dutch',
                    name: 'Kenmerken',
                },
                {
                    language: 'Arabic',
                    name: 'المميزات',
                },
            ],
            iceCategories: [
                {
                    categoryId: 10,
                    sortOrder: 3,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Golf',
                        },
                        {
                            language: 'German',
                            name: 'Golfplatz',
                        },
                        {
                            language: 'French',
                            name: 'Parcours de golf',
                        },
                        {
                            language: 'Spanish',
                            name: 'Campo de golf',
                        },
                        {
                            language: 'Italian',
                            name: 'Campo da golf',
                        },
                        {
                            language: 'Chinese',
                            name: '高尔夫球',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Campo de golfe',
                        },
                        {
                            language: 'Japanese',
                            name: 'ゴルフ',
                        },
                        {
                            language: 'Korean',
                            name: '골프',
                        },
                        {
                            language: 'Russian',
                            name: 'Гольф',
                        },
                        {
                            language: 'Dutch',
                            name: 'Golf',
                        },
                        {
                            language: 'Arabic',
                            name: 'الجولف',
                        },
                    ],
                },
                {
                    categoryId: 11,
                    sortOrder: 1,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Beach',
                        },
                        {
                            language: 'German',
                            name: 'Strand',
                        },
                        {
                            language: 'French',
                            name: 'Plage',
                        },
                        {
                            language: 'Spanish',
                            name: 'Playa',
                        },
                        {
                            language: 'Italian',
                            name: 'Spiaggia',
                        },
                        {
                            language: 'Chinese',
                            name: '海滩',
                        },
                        {
                            language: 'Portuguese',
                            name: 'De praia',
                        },
                        {
                            language: 'Japanese',
                            name: 'ビーチ',
                        },
                        {
                            language: 'Korean',
                            name: '해변',
                        },
                        {
                            language: 'Russian',
                            name: 'Пляж',
                        },
                        {
                            language: 'Dutch',
                            name: 'Strand',
                        },
                        {
                            language: 'Arabic',
                            name: 'شاطئ',
                        },
                    ],
                },
                {
                    categoryId: 12,
                    sortOrder: 4,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Spa',
                        },
                        {
                            language: 'German',
                            name: 'Spa',
                        },
                        {
                            language: 'French',
                            name: 'Spa',
                        },
                        {
                            language: 'Spanish',
                            name: 'Spa',
                        },
                        {
                            language: 'Italian',
                            name: 'Spa',
                        },
                        {
                            language: 'Chinese',
                            name: '温泉',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Spa',
                        },
                        {
                            language: 'Japanese',
                            name: 'スパ',
                        },
                        {
                            language: 'Korean',
                            name: '온천',
                        },
                        {
                            language: 'Russian',
                            name: 'спа',
                        },
                        {
                            language: 'Dutch',
                            name: 'Spa',
                        },
                        {
                            language: 'Arabic',
                            name: 'منتجع صحي',
                        },
                    ],
                },
                {
                    categoryId: 29,
                    sortOrder: 2,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Casino',
                        },
                        {
                            language: 'German',
                            name: 'Casino',
                        },
                        {
                            language: 'French',
                            name: 'Casino',
                        },
                        {
                            language: 'Spanish',
                            name: 'Casino',
                        },
                        {
                            language: 'Italian',
                            name: 'Casinò',
                        },
                        {
                            language: 'Chinese',
                            name: '赌场',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Cassino',
                        },
                        {
                            language: 'Japanese',
                            name: 'カジノ',
                        },
                        {
                            language: 'Korean',
                            name: '카지노',
                        },
                        {
                            language: 'Russian',
                            name: 'Казино',
                        },
                        {
                            language: 'Dutch',
                            name: 'Casino',
                        },
                        {
                            language: 'Arabic',
                            name: 'كازينو',
                        },
                    ],
                },
            ],
        },
        {
            groupId: 5,
            sortOrder: 5,
            groupTranslations: [
                {
                    language: 'English',
                    name: 'Health/Fitness/Gym',
                },
                {
                    language: 'German',
                    name: 'Gesundheit/Fitness/Fitnessstudio',
                },
                {
                    language: 'French',
                    name: 'Santé/Fitness/Gym',
                },
                {
                    language: 'Spanish',
                    name: 'Salud/Fitness/Gimnasio',
                },
                {
                    language: 'Portuguese',
                    name: 'Saúde/Fitness/Ginásio',
                },
                {
                    language: 'Japanese',
                    name: '健康・フィットネス・ジム',
                },
                {
                    language: 'Chinese',
                    name: '健身房',
                },
                {
                    language: 'Italian',
                    name: 'Salute/Fitness/Palestra',
                },
                {
                    language: 'Korean',
                    name: '헬스/피트니스/체육관',
                },
                {
                    language: 'Russian',
                    name: 'Здоровье/Фитнес/Тренажерный зал',
                },
                {
                    language: 'Dutch',
                    name: 'Gezondheid/Fitness/Sportschool',
                },
                {
                    language: 'Arabic',
                    name: 'الصحة / اللياقة / الصالة الرياضية',
                },
            ],
            iceCategories: [
                {
                    categoryId: 5,
                    sortOrder: 1,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Health club',
                        },
                        {
                            language: 'German',
                            name: 'Gesundheitsclub / Fitnesscenter / Fitnessstudio',
                        },
                        {
                            language: 'French',
                            name: 'Club de santé / centre de fitness / gym',
                        },
                        {
                            language: 'Spanish',
                            name: 'Club de salud / centro de fitness / gimnasio',
                        },
                        {
                            language: 'Italian',
                            name: 'Centro benessere / centro fitness / palestra',
                        },
                        {
                            language: 'Chinese',
                            name: '健身俱乐部/健身中心/健身房',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Clube de saúde / academia / academia',
                        },
                        {
                            language: 'Japanese',
                            name: 'ヘルスクラブ/フィットネスセンター/ジム',
                        },
                        {
                            language: 'Korean',
                            name: '헬스클럽/피트니스센터/체육관',
                        },
                        {
                            language: 'Russian',
                            name: 'Оздоровительный клуб/фитнес-центр/тренажерный зал',
                        },
                        {
                            language: 'Dutch',
                            name: 'Healthclub / fitnesscentrum / sportschool',
                        },
                        {
                            language: 'Arabic',
                            name: 'نادي صحي / مركز لياقة / صالة ألعاب رياضية',
                        },
                    ],
                },
            ],
        },
        {
            groupId: 6,
            sortOrder: 6,
            groupTranslations: [
                {
                    language: 'English',
                    name: 'Pool',
                },
                {
                    language: 'German',
                    name: 'Merkmale',
                },
                {
                    language: 'French',
                    name: 'Caractéristiques',
                },
                {
                    language: 'Spanish',
                    name: 'Características',
                },
                {
                    language: 'Portuguese',
                    name: 'Recursos',
                },
                {
                    language: 'Japanese',
                    name: '特徴',
                },
                {
                    language: 'Chinese',
                    name: '特点',
                },
                {
                    language: 'Italian',
                    name: 'Caratteristiche',
                },
                {
                    language: 'Korean',
                    name: '특징',
                },
                {
                    language: 'Russian',
                    name: 'Особенности',
                },
                {
                    language: 'Dutch',
                    name: 'Kenmerken',
                },
                {
                    language: 'Arabic',
                    name: 'المميزات',
                },
            ],
            iceCategories: [
                {
                    categoryId: 3,
                    sortOrder: 1,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Pool',
                        },
                        {
                            language: 'German',
                            name: 'Pool',
                        },
                        {
                            language: 'French',
                            name: 'Piscine',
                        },
                        {
                            language: 'Spanish',
                            name: 'Piscina',
                        },
                        {
                            language: 'Italian',
                            name: 'Piscina',
                        },
                        {
                            language: 'Chinese',
                            name: '水池',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Piscina',
                        },
                        {
                            language: 'Japanese',
                            name: 'プール',
                        },
                        {
                            language: 'Korean',
                            name: '수영장',
                        },
                        {
                            language: 'Russian',
                            name: 'Бассейн',
                        },
                        {
                            language: 'Dutch',
                            name: 'Zwembad',
                        },
                        {
                            language: 'Arabic',
                            name: 'حوض السباحة',
                        },
                    ],
                },
                {
                    categoryId: 30,
                    sortOrder: 2,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Pool - indoor',
                        },
                        {
                            language: 'German',
                            name: 'Innenpool',
                        },
                        {
                            language: 'French',
                            name: 'Piscine - Intérieure',
                        },
                        {
                            language: 'Spanish',
                            name: 'Piscina: interior',
                        },
                        {
                            language: 'Italian',
                            name: 'Piscina coperta',
                        },
                        {
                            language: 'Chinese',
                            name: '游泳池 - 室内',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Piscina interior',
                        },
                        {
                            language: 'Japanese',
                            name: 'プール-屋内',
                        },
                        {
                            language: 'Korean',
                            name: '수영장 - 실내',
                        },
                        {
                            language: 'Russian',
                            name: 'Бассейн - крытый',
                        },
                        {
                            language: 'Dutch',
                            name: 'Zwembad - binnen',
                        },
                        {
                            language: 'Arabic',
                            name: 'حمام سباحة - داخلي',
                        },
                    ],
                },
                {
                    categoryId: 31,
                    sortOrder: 3,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Pool - outdoor',
                        },
                        {
                            language: 'German',
                            name: 'Außenpool',
                        },
                        {
                            language: 'French',
                            name: 'Piscine - Extérieure',
                        },
                        {
                            language: 'Spanish',
                            name: 'Piscina: exterior',
                        },
                        {
                            language: 'Italian',
                            name: 'Piscina scoperta',
                        },
                        {
                            language: 'Chinese',
                            name: '游泳池 - 户外',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Piscina exterior',
                        },
                        {
                            language: 'Japanese',
                            name: 'プール-屋外',
                        },
                        {
                            language: 'Korean',
                            name: '수영장 - 야외',
                        },
                        {
                            language: 'Russian',
                            name: 'Бассейн - открытый',
                        },
                        {
                            language: 'Dutch',
                            name: 'Zwembad - buiten',
                        },
                        {
                            language: 'Arabic',
                            name: 'حمام سباحة - خارجي',
                        },
                    ],
                },
            ],
        },
        {
            groupId: 7,
            sortOrder: 7,
            groupTranslations: [
                {
                    language: 'English',
                    name: 'Dining',
                },
                {
                    language: 'German',
                    name: 'Essen',
                },
                {
                    language: 'French',
                    name: 'Restauration',
                },
                {
                    language: 'Spanish',
                    name: 'Comedor',
                },
                {
                    language: 'Portuguese',
                    name: 'Refeições',
                },
                {
                    language: 'Japanese',
                    name: 'ダイニング',
                },
                {
                    language: 'Chinese',
                    name: '餐饮',
                },
                {
                    language: 'Italian',
                    name: 'Ristorazione',
                },
                {
                    language: 'Korean',
                    name: '다이닝',
                },
                {
                    language: 'Russian',
                    name: 'Ресторан',
                },
                {
                    language: 'Dutch',
                    name: 'Dineren',
                },
                {
                    language: 'Arabic',
                    name: 'تناول الطعام',
                },
            ],
            iceCategories: [
                {
                    categoryId: 4,
                    sortOrder: 4,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Restaurant',
                        },
                        {
                            language: 'German',
                            name: 'Restaurant',
                        },
                        {
                            language: 'French',
                            name: 'Restaurant',
                        },
                        {
                            language: 'Spanish',
                            name: 'Restaurante',
                        },
                        {
                            language: 'Italian',
                            name: 'Ristorante',
                        },
                        {
                            language: 'Chinese',
                            name: '餐厅',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Restaurante',
                        },
                        {
                            language: 'Japanese',
                            name: 'レストラン',
                        },
                        {
                            language: 'Korean',
                            name: '식당',
                        },
                        {
                            language: 'Russian',
                            name: 'Ресторан',
                        },
                        {
                            language: 'Dutch',
                            name: 'Restaurant',
                        },
                        {
                            language: 'Arabic',
                            name: 'مطعم',
                        },
                    ],
                },
                {
                    categoryId: 13,
                    sortOrder: 1,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Bar/Lounge',
                        },
                        {
                            language: 'German',
                            name: 'Bar-Lounge',
                        },
                        {
                            language: 'French',
                            name: 'Bar-salon',
                        },
                        {
                            language: 'Spanish',
                            name: 'Bar lounge',
                        },
                        {
                            language: 'Italian',
                            name: 'Lounge bar',
                        },
                        {
                            language: 'Chinese',
                            name: '酒吧/酒廊',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Salão do bar',
                        },
                        {
                            language: 'Japanese',
                            name: 'バー/ラウンジ',
                        },
                        {
                            language: 'Korean',
                            name: '바/라운지',
                        },
                        {
                            language: 'Russian',
                            name: 'Бар/Лаунж',
                        },
                        {
                            language: 'Dutch',
                            name: 'Bar lounge',
                        },
                        {
                            language: 'Arabic',
                            name: 'بار / ردهة',
                        },
                    ],
                },
                {
                    categoryId: 28,
                    sortOrder: 2,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Breakfast Area',
                        },
                        {
                            language: 'German',
                            name: 'Frühstücksbereich',
                        },
                        {
                            language: 'French',
                            name: 'Espace petit-déjeuner',
                        },
                        {
                            language: 'Spanish',
                            name: 'Área de desayuno',
                        },
                        {
                            language: 'Italian',
                            name: 'Area colazione',
                        },
                        {
                            language: 'Chinese',
                            name: '早餐区',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Área de café da manhã',
                        },
                        {
                            language: 'Japanese',
                            name: '朝食エリア',
                        },
                        {
                            language: 'Korean',
                            name: '아침 식사 공간',
                        },
                        {
                            language: 'Russian',
                            name: 'Зона для завтрака',
                        },
                        {
                            language: 'Dutch',
                            name: 'Ontbijtruimte',
                        },
                        {
                            language: 'Arabic',
                            name: 'منطقة الإفطار',
                        },
                    ],
                },
                {
                    categoryId: 41,
                    sortOrder: 3,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Food and Drink',
                        },
                        {
                            language: 'German',
                            name: 'Essen und Trinken',
                        },
                        {
                            language: 'French',
                            name: 'Nourriture et boisson',
                        },
                        {
                            language: 'Spanish',
                            name: 'Comida y bebida',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Comida e bebida',
                        },
                        {
                            language: 'Japanese',
                            name: '??',
                        },
                        {
                            language: 'Chinese',
                            name: '??',
                        },
                        {
                            language: 'Italian',
                            name: 'Cibo e bevande',
                        },
                        {
                            language: 'Korean',
                            name: '??? ??',
                        },
                        {
                            language: 'Russian',
                            name: '??? ? ???????',
                        },
                        {
                            language: 'Dutch',
                            name: 'Eten en drinken',
                        },
                        {
                            language: 'Arabic',
                            name: '???? ? ????',
                        },
                    ],
                },
            ],
        },
        {
            groupId: 8,
            sortOrder: 8,
            groupTranslations: [
                {
                    language: 'English',
                    name: 'Property amenities',
                },
                {
                    language: 'German',
                    name: 'Unterkunftseinrichtungen',
                },
                {
                    language: 'French',
                    name: 'Équipements de l’établissement',
                },
                {
                    language: 'Spanish',
                    name: 'Servicios del alojamiento',
                },
                {
                    language: 'Portuguese',
                    name: 'Comodidades da propriedade',
                },
                {
                    language: 'Japanese',
                    name: '施設設備',
                },
                {
                    language: 'Chinese',
                    name: '物业设施',
                },
                {
                    language: 'Italian',
                    name: 'Servizi della struttura',
                },
                {
                    language: 'Korean',
                    name: '숙소 편의시설',
                },
                {
                    language: 'Russian',
                    name: 'Удобства объекта',
                },
                {
                    language: 'Dutch',
                    name: 'Voorzieningen accommodatie',
                },
                {
                    language: 'Arabic',
                    name: 'مرافق الفندق',
                },
            ],
            iceCategories: [
                {
                    categoryId: 14,
                    sortOrder: 7,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Recreational facility',
                        },
                        {
                            language: 'German',
                            name: 'Freizeiteinrichtung',
                        },
                        {
                            language: 'French',
                            name: 'Centre de loisirs',
                        },
                        {
                            language: 'Spanish',
                            name: 'Instalación recreacional',
                        },
                        {
                            language: 'Italian',
                            name: 'Struttura ricreativa',
                        },
                        {
                            language: 'Chinese',
                            name: '娱乐设施',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Instalação recreativa',
                        },
                        {
                            language: 'Japanese',
                            name: 'レクリエーション施設',
                        },
                        {
                            language: 'Korean',
                            name: '레크리에이션 시설',
                        },
                        {
                            language: 'Russian',
                            name: 'База отдыха',
                        },
                        {
                            language: 'Dutch',
                            name: 'Recreatieve voorziening',
                        },
                        {
                            language: 'Arabic',
                            name: 'مرفق ترفيهي',
                        },
                    ],
                },
                {
                    categoryId: 22,
                    sortOrder: 6,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Property amenity',
                        },
                        {
                            language: 'German',
                            name: 'Hotelanlagen',
                        },
                        {
                            language: 'French',
                            name: 'Services de la propriété',
                        },
                        {
                            language: 'Spanish',
                            name: 'Servicios de la propiedad',
                        },
                        {
                            language: 'Italian',
                            name: 'Dotazioni dell’hotel',
                        },
                        {
                            language: 'Chinese',
                            name: '物业设施',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Instalações do hotel',
                        },
                        {
                            language: 'Japanese',
                            name: 'プロパティのアメニティ',
                        },
                        {
                            language: 'Korean',
                            name: '숙박 시설',
                        },
                        {
                            language: 'Russian',
                            name: 'Удобства в отеле',
                        },
                        {
                            language: 'Dutch',
                            name: 'Accommodatievoorziening',
                        },
                        {
                            language: 'Arabic',
                            name: 'وسائل الراحة في الممتلكات',
                        },
                    ],
                },
                {
                    categoryId: 23,
                    sortOrder: 2,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Business Center',
                        },
                        {
                            language: 'German',
                            name: 'Business-Center',
                        },
                        {
                            language: 'French',
                            name: 'Centre d’affaires',
                        },
                        {
                            language: 'Spanish',
                            name: 'Centro de negocios',
                        },
                        {
                            language: 'Italian',
                            name: 'Centro affari',
                        },
                        {
                            language: 'Chinese',
                            name: '商业中心',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Centro de negócios',
                        },
                        {
                            language: 'Japanese',
                            name: 'ビジネスセンター',
                        },
                        {
                            language: 'Korean',
                            name: '비즈니스 센터',
                        },
                        {
                            language: 'Russian',
                            name: 'Бизнес центр',
                        },
                        {
                            language: 'Dutch',
                            name: 'Zakencentrum',
                        },
                        {
                            language: 'Arabic',
                            name: 'مركز أعمال',
                        },
                    ],
                },
                {
                    categoryId: 33,
                    sortOrder: 4,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Laundry',
                        },
                        {
                            language: 'German',
                            name: 'Wäscherei',
                        },
                        {
                            language: 'French',
                            name: 'Laverie',
                        },
                        {
                            language: 'Spanish',
                            name: 'Lavandería',
                        },
                        {
                            language: 'Italian',
                            name: 'Servizi lavanderia',
                        },
                        {
                            language: 'Chinese',
                            name: '洗衣店',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Lavanderia',
                        },
                        {
                            language: 'Japanese',
                            name: 'ランドリー',
                        },
                        {
                            language: 'Korean',
                            name: '빨래',
                        },
                        {
                            language: 'Russian',
                            name: 'Прачечная',
                        },
                        {
                            language: 'Dutch',
                            name: 'De was',
                        },
                        {
                            language: 'Arabic',
                            name: 'مغسلة',
                        },
                    ],
                },
                {
                    categoryId: 34,
                    sortOrder: 5,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Local attraction',
                        },
                        {
                            language: 'German',
                            name: 'Lokale Sehenswürdigkeit',
                        },
                        {
                            language: 'French',
                            name: 'Attraction locale',
                        },
                        {
                            language: 'Spanish',
                            name: 'Atracciones o lugares de interés locales',
                        },
                        {
                            language: 'Italian',
                            name: 'Attrazione locale',
                        },
                        {
                            language: 'Chinese',
                            name: '当地景点',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Atração local',
                        },
                        {
                            language: 'Japanese',
                            name: '地元の魅力',
                        },
                        {
                            language: 'Korean',
                            name: '지역 명소',
                        },
                        {
                            language: 'Russian',
                            name: 'Местная достопримечательность',
                        },
                        {
                            language: 'Dutch',
                            name: 'Lokale attractie',
                        },
                        {
                            language: 'Arabic',
                            name: 'جاذبية محلية',
                        },
                    ],
                },
                {
                    categoryId: 42,
                    sortOrder: 1,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Accessibility',
                        },
                        {
                            language: 'German',
                            name: 'Barrierefreiheit',
                        },
                        {
                            language: 'French',
                            name: 'Accessibilité',
                        },
                        {
                            language: 'Spanish',
                            name: 'Accesibilidad',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Acessibilidade',
                        },
                        {
                            language: 'Japanese',
                            name: 'アクセシビリティ',
                        },
                        {
                            language: 'Chinese',
                            name: '无障碍',
                        },
                        {
                            language: 'Italian',
                            name: 'Accessibilità',
                        },
                        {
                            language: 'Korean',
                            name: '접근성',
                        },
                        {
                            language: 'Russian',
                            name: 'Доступность',
                        },
                        {
                            language: 'Dutch',
                            name: 'Toegankelijkheid',
                        },
                        {
                            language: 'Arabic',
                            name: 'إمكانية الوصول',
                        },
                    ],
                },
                {
                    categoryId: 43,
                    sortOrder: 10,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'View from property',
                        },
                        {
                            language: 'German',
                            name: 'Blick vom Grundstück',
                        },
                        {
                            language: 'French',
                            name: 'Vue depuis la propriété',
                        },
                        {
                            language: 'Spanish',
                            name: 'Vista desde la propiedad',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Vista da propriedade',
                        },
                        {
                            language: 'Japanese',
                            name: '物件からの眺め',
                        },
                        {
                            language: 'Chinese',
                            name: '从属性看',
                        },
                        {
                            language: 'Italian',
                            name: 'Vista dalla proprietà',
                        },
                        {
                            language: 'Korean',
                            name: '숙소에서 보이는 전망',
                        },
                        {
                            language: 'Russian',
                            name: 'Вид из объекта размещения',
                        },
                        {
                            language: 'Dutch',
                            name: 'Uitzicht vanaf eigendom',
                        },
                        {
                            language: 'Arabic',
                            name: 'عرض من الممتلكات',
                        },
                    ],
                },
                {
                    categoryId: 44,
                    sortOrder: 8,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Shuttle/Transfer',
                        },
                        {
                            language: 'German',
                            name: 'Shuttle/Transfer',
                        },
                        {
                            language: 'French',
                            name: 'Navette/Transfert',
                        },
                        {
                            language: 'Spanish',
                            name: 'Lanzadera/Traslado',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Transporte/Transferência',
                        },
                        {
                            language: 'Japanese',
                            name: 'シャトル/送迎',
                        },
                        {
                            language: 'Chinese',
                            name: '班车/接送',
                        },
                        {
                            language: 'Italian',
                            name: 'Navetta/trasferimento',
                        },
                        {
                            language: 'Korean',
                            name: '셔틀/환승',
                        },
                        {
                            language: 'Russian',
                            name: 'Трансфер/Трансфер',
                        },
                        {
                            language: 'Dutch',
                            name: 'Pendeldienst/transfer',
                        },
                        {
                            language: 'Arabic',
                            name: 'المكوك / النقل',
                        },
                    ],
                },
                {
                    categoryId: 45,
                    sortOrder: 3,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Certificates',
                        },
                        {
                            language: 'German',
                            name: 'Zertifikate',
                        },
                        {
                            language: 'French',
                            name: 'Certificats',
                        },
                        {
                            language: 'Spanish',
                            name: 'Certificados',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Certificados',
                        },
                        {
                            language: 'Japanese',
                            name: '証明書',
                        },
                        {
                            language: 'Chinese',
                            name: '证书',
                        },
                        {
                            language: 'Italian',
                            name: 'Certificati',
                        },
                        {
                            language: 'Korean',
                            name: '인증서',
                        },
                        {
                            language: 'Russian',
                            name: 'Сертификаты',
                        },
                        {
                            language: 'Dutch',
                            name: 'Certificaten',
                        },
                        {
                            language: 'Arabic',
                            name: 'الشهادات',
                        },
                    ],
                },
                {
                    categoryId: 46,
                    sortOrder: 9,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Sustainability',
                        },
                        {
                            language: 'German',
                            name: 'Nachhaltigkeit',
                        },
                        {
                            language: 'French',
                            name: 'Durabilité',
                        },
                        {
                            language: 'Spanish',
                            name: 'Sostenibilidad',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Sustentabilidade',
                        },
                        {
                            language: 'Japanese',
                            name: '持続可能性',
                        },
                        {
                            language: 'Chinese',
                            name: '可持续发展',
                        },
                        {
                            language: 'Italian',
                            name: 'Sostenibilità',
                        },
                        {
                            language: 'Korean',
                            name: '지속 가능성',
                        },
                        {
                            language: 'Russian',
                            name: 'Устойчивое развитие',
                        },
                        {
                            language: 'Dutch',
                            name: 'Duurzaamheid',
                        },
                        {
                            language: 'Arabic',
                            name: 'الاستدامة',
                        },
                    ],
                },
            ],
        },
        {
            groupId: 9,
            sortOrder: 9,
            groupTranslations: [
                {
                    language: 'English',
                    name: 'Event Spaces',
                },
                {
                    language: 'German',
                    name: 'Veranstaltungsräume',
                },
                {
                    language: 'French',
                    name: 'Espaces événementiels',
                },
                {
                    language: 'Spanish',
                    name: 'Espacios para eventos',
                },
                {
                    language: 'Portuguese',
                    name: 'Espaços para eventos',
                },
                {
                    language: 'Japanese',
                    name: 'イベントスペース',
                },
                {
                    language: 'Chinese',
                    name: '活动空间',
                },
                {
                    language: 'Italian',
                    name: 'Spazi per eventi',
                },
                {
                    language: 'Korean',
                    name: '이벤트 공간',
                },
                {
                    language: 'Russian',
                    name: 'Мероприятия',
                },
                {
                    language: 'Dutch',
                    name: 'Evenementruimten',
                },
                {
                    language: 'Arabic',
                    name: 'قاعات المناسبات',
                },
            ],
            iceCategories: [
                {
                    categoryId: 8,
                    sortOrder: 2,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Meeting room',
                        },
                        {
                            language: 'German',
                            name: 'Tagungsraum',
                        },
                        {
                            language: 'French',
                            name: 'Salle de réunion',
                        },
                        {
                            language: 'Spanish',
                            name: 'Sala de reuniones',
                        },
                        {
                            language: 'Italian',
                            name: 'Sala riunioni',
                        },
                        {
                            language: 'Chinese',
                            name: '会议室',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Sala de reuniões',
                        },
                        {
                            language: 'Japanese',
                            name: '会議室',
                        },
                        {
                            language: 'Korean',
                            name: '회의실',
                        },
                        {
                            language: 'Russian',
                            name: 'Комната для переговоров',
                        },
                        {
                            language: 'Dutch',
                            name: 'Vergaderzaal',
                        },
                        {
                            language: 'Arabic',
                            name: 'قاعة الاجتماعات',
                        },
                    ],
                },
                {
                    categoryId: 9,
                    sortOrder: 1,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Ballroom',
                        },
                        {
                            language: 'German',
                            name: 'Ballsaal',
                        },
                        {
                            language: 'French',
                            name: 'Ballroom',
                        },
                        {
                            language: 'Spanish',
                            name: 'Salón de baile',
                        },
                        {
                            language: 'Italian',
                            name: 'Sala da ballo',
                        },
                        {
                            language: 'Chinese',
                            name: '舞厅',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Salão de baile',
                        },
                        {
                            language: 'Japanese',
                            name: 'ボールルーム',
                        },
                        {
                            language: 'Korean',
                            name: '사교 댄스',
                        },
                        {
                            language: 'Russian',
                            name: 'бальный зал',
                        },
                        {
                            language: 'Dutch',
                            name: 'balzaal',
                        },
                        {
                            language: 'Arabic',
                            name: 'قاعة رقص',
                        },
                    ],
                },
                {
                    categoryId: 32,
                    sortOrder: 3,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Wedding',
                        },
                        {
                            language: 'German',
                            name: 'Hochzeit',
                        },
                        {
                            language: 'French',
                            name: 'Mariage',
                        },
                        {
                            language: 'Spanish',
                            name: 'Boda',
                        },
                        {
                            language: 'Italian',
                            name: 'Matrimoni',
                        },
                        {
                            language: 'Chinese',
                            name: '婚礼',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Casamento',
                        },
                        {
                            language: 'Japanese',
                            name: '結婚式',
                        },
                        {
                            language: 'Korean',
                            name: '혼례',
                        },
                        {
                            language: 'Russian',
                            name: 'Свадьба',
                        },
                        {
                            language: 'Dutch',
                            name: 'Bruiloft',
                        },
                        {
                            language: 'Arabic',
                            name: 'حفل زواج',
                        },
                    ],
                },
            ],
        },
        {
            groupId: 10,
            sortOrder: 10,
            groupTranslations: [
                {
                    language: 'English',
                    name: 'Other',
                },
                {
                    language: 'German',
                    name: 'Sonstiges',
                },
                {
                    language: 'French',
                    name: 'Autre',
                },
                {
                    language: 'Spanish',
                    name: 'Otros',
                },
                {
                    language: 'Portuguese',
                    name: 'Outros',
                },
                {
                    language: 'Japanese',
                    name: 'その他',
                },
                {
                    language: 'Chinese',
                    name: '其他',
                },
                {
                    language: 'Italian',
                    name: 'Altro',
                },
                {
                    language: 'Korean',
                    name: '기타',
                },
                {
                    language: 'Russian',
                    name: 'Другое',
                },
                {
                    language: 'Dutch',
                    name: 'Overige',
                },
                {
                    language: 'Arabic',
                    name: 'أخرى',
                },
            ],
            iceCategories: [
                {
                    categoryId: 0,
                    sortOrder: 1,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Undefined',
                        },
                        {
                            language: 'German',
                            name: 'Unbestimmt',
                        },
                        {
                            language: 'French',
                            name: 'Non défini',
                        },
                        {
                            language: 'Spanish',
                            name: 'Sin definir',
                        },
                        {
                            language: 'Italian',
                            name: 'Indefinito',
                        },
                        {
                            language: 'Chinese',
                            name: '不明确的',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Indeterminado',
                        },
                        {
                            language: 'Japanese',
                            name: '未定義',
                        },
                        {
                            language: 'Korean',
                            name: '찾으시는 주소가 없습니다',
                        },
                        {
                            language: 'Russian',
                            name: 'Неопределенный',
                        },
                        {
                            language: 'Dutch',
                            name: 'Niet gedefinieerd',
                        },
                        {
                            language: 'Arabic',
                            name: 'غير معرف',
                        },
                    ],
                },
                {
                    categoryId: 15,
                    sortOrder: 4,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Logo',
                        },
                        {
                            language: 'German',
                            name: 'Logo',
                        },
                        {
                            language: 'French',
                            name: 'Logo',
                        },
                        {
                            language: 'Spanish',
                            name: 'Logotipo',
                        },
                        {
                            language: 'Italian',
                            name: 'Logo',
                        },
                        {
                            language: 'Chinese',
                            name: '标识',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Logotipo',
                        },
                        {
                            language: 'Japanese',
                            name: 'ロゴ',
                        },
                        {
                            language: 'Korean',
                            name: '심벌 마크',
                        },
                        {
                            language: 'Russian',
                            name: 'Логотип',
                        },
                        {
                            language: 'Dutch',
                            name: 'Logo',
                        },
                        {
                            language: 'Arabic',
                            name: 'شعار',
                        },
                    ],
                },
                {
                    categoryId: 16,
                    sortOrder: 2,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Basics',
                        },
                        {
                            language: 'German',
                            name: 'Grundlagen',
                        },
                        {
                            language: 'French',
                            name: 'Basiques',
                        },
                        {
                            language: 'Spanish',
                            name: 'Bases',
                        },
                        {
                            language: 'Italian',
                            name: 'Principi',
                        },
                        {
                            language: 'Chinese',
                            name: '基本',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Fundamentos',
                        },
                        {
                            language: 'Japanese',
                            name: '基本',
                        },
                        {
                            language: 'Korean',
                            name: '기초',
                        },
                        {
                            language: 'Russian',
                            name: 'Основы',
                        },
                        {
                            language: 'Dutch',
                            name: 'Basis',
                        },
                        {
                            language: 'Arabic',
                            name: 'الأساسيات',
                        },
                    ],
                },
                {
                    categoryId: 17,
                    sortOrder: 5,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Map',
                        },
                        {
                            language: 'German',
                            name: 'Karte',
                        },
                        {
                            language: 'French',
                            name: 'Carte',
                        },
                        {
                            language: 'Spanish',
                            name: 'Mapa',
                        },
                        {
                            language: 'Italian',
                            name: 'Mappa',
                        },
                        {
                            language: 'Chinese',
                            name: '地图',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Mapa',
                        },
                        {
                            language: 'Japanese',
                            name: '地図',
                        },
                        {
                            language: 'Korean',
                            name: '지도',
                        },
                        {
                            language: 'Russian',
                            name: 'карта',
                        },
                        {
                            language: 'Dutch',
                            name: 'Kaart',
                        },
                        {
                            language: 'Arabic',
                            name: 'خريطة',
                        },
                    ],
                },
                {
                    categoryId: 18,
                    sortOrder: 7,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Promotional',
                        },
                        {
                            language: 'German',
                            name: 'Werbeaktion',
                        },
                        {
                            language: 'French',
                            name: 'Promotionnel',
                        },
                        {
                            language: 'Spanish',
                            name: 'Promocional',
                        },
                        {
                            language: 'Italian',
                            name: 'Promozionale',
                        },
                        {
                            language: 'Chinese',
                            name: '促销',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Promoção',
                        },
                        {
                            language: 'Japanese',
                            name: 'プロモーション',
                        },
                        {
                            language: 'Korean',
                            name: '판촉',
                        },
                        {
                            language: 'Russian',
                            name: 'Рекламный',
                        },
                        {
                            language: 'Dutch',
                            name: 'promotioneel',
                        },
                        {
                            language: 'Arabic',
                            name: 'الترويجية',
                        },
                    ],
                },
                {
                    categoryId: 19,
                    sortOrder: 3,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Hot news',
                        },
                        {
                            language: 'German',
                            name: 'Aktuelle Nachrichten',
                        },
                        {
                            language: 'French',
                            name: 'Dernières nouvelles',
                        },
                        {
                            language: 'Spanish',
                            name: 'Noticias frescas',
                        },
                        {
                            language: 'Italian',
                            name: 'Novità',
                        },
                        {
                            language: 'Chinese',
                            name: '热点新闻',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Últimas notícias',
                        },
                        {
                            language: 'Japanese',
                            name: 'ホットニュース',
                        },
                        {
                            language: 'Korean',
                            name: '핫 뉴스',
                        },
                        {
                            language: 'Russian',
                            name: 'Горячие новости',
                        },
                        {
                            language: 'Dutch',
                            name: 'Brekend nieuws',
                        },
                        {
                            language: 'Arabic',
                            name: 'أخبار عاجلة',
                        },
                    ],
                },
                {
                    categoryId: 20,
                    sortOrder: 6,
                    categoryTranslations: [
                        {
                            language: 'English',
                            name: 'Miscellaneous',
                        },
                        {
                            language: 'German',
                            name: 'Verschiedenes',
                        },
                        {
                            language: 'French',
                            name: 'Divers',
                        },
                        {
                            language: 'Spanish',
                            name: 'Otros',
                        },
                        {
                            language: 'Italian',
                            name: 'Varie',
                        },
                        {
                            language: 'Chinese',
                            name: '各种各样的',
                        },
                        {
                            language: 'Portuguese',
                            name: 'Vários',
                        },
                        {
                            language: 'Japanese',
                            name: 'その他',
                        },
                        {
                            language: 'Korean',
                            name: '여러 가지 잡다한',
                        },
                        {
                            language: 'Russian',
                            name: 'Разное',
                        },
                        {
                            language: 'Dutch',
                            name: 'Gemengd',
                        },
                        {
                            language: 'Arabic',
                            name: 'متفرقات',
                        },
                    ],
                },
            ],
        },
    ],
};
